import { DonationCampaign } from 'store/types/DonationFund';
import DonationCampaignStatus from 'store/enums/DonationCampaignStatus';
import { SiteThemes } from 'store/types/SiteConfig';
import { ConfigSelectOption } from 'store/types/SelectOption';
import React from 'react';
import StatusLabel from 'components/shared/StatusLabel';

export const isCampaignParent = ({ allowPersonalizedCampaign, status }: DonationCampaign): boolean =>
  status === DonationCampaignStatus.Active && !!allowPersonalizedCampaign;

export const getDonationCampaignStatusConfig = ({
  isGamsdTheme,
  isCompassTheme,
}: SiteThemes): Record<DonationCampaignStatus, ConfigSelectOption> => ({
  [DonationCampaignStatus.Active]: {
    name: 'Active',
    theme: isGamsdTheme ? 'light-green' : isCompassTheme ? 'bright-green' : 'green',
  },
  [DonationCampaignStatus.Approved]: {
    name: 'Approved - Pending Activation',
    theme: 'yellow',
  },
  [DonationCampaignStatus.Submitted]: {
    name: 'Submitted - Pending Review',
    theme: 'blue',
  },
  [DonationCampaignStatus.Closed]: {
    name: 'Closed',
    theme: 'grey',
  },
  [DonationCampaignStatus.Expired]: {
    name: 'Expired',
    theme: 'grey',
  },
  [DonationCampaignStatus.Rejected]: {
    name: 'Rejected',
    theme: 'red',
  },
});

export const getDonationStatusLabel = (
  status: DonationCampaignStatus = DonationCampaignStatus.Active,
  { isGamsdTheme, isCompassTheme }: SiteThemes
): React.ReactNode => {
  const donationStatusConfig = getDonationCampaignStatusConfig({ isGamsdTheme, isCompassTheme });
  const { theme = 'grey', name = '' } = donationStatusConfig[status];

  return <StatusLabel theme={theme} status={name} />;
};
